(() => {
	/**
	 * Email CTA.
	 *
	 * Never submits anywhere itself: it opens the popup named in
	 * `data-email-cta` and hands the address to that popup's email field, then
	 * moves focus to the first field still empty. The browser's own email
	 * validation runs before `submit` fires, so a blank or malformed address
	 * never gets this far.
	 */
	document.querySelectorAll('form[data-email-cta]').forEach((form) => {
		form.addEventListener('submit', (event) => {
			event.preventDefault();

			const slug = form.dataset.emailCta;
			const dialog = document.getElementById(`popup-${slug}`);
			if (!dialog || !window.LLPopup) return;

			const target = dialog.querySelector('input[type="email"]');
			if (target) {
				target.value = form.elements.email.value.trim();
				// Gravity Forms' conditional logic listens for these.
				target.dispatchEvent(new Event('input', { bubbles: true }));
				target.dispatchEvent(new Event('change', { bubbles: true }));
			}

			window.LLPopup.open(slug);

			const next = Array.from(dialog.querySelectorAll('input:not([type="hidden"]), select, textarea'))
				.find((field) => !field.value && !field.disabled && field.getClientRects().length);
			if (next) next.focus();
		});
	});
})();
